import React, { Component } from 'react';
import { connect } from "react-redux";

import './../../../scss/App.scss';
import { trackingWrapper } from '../../utils/analytics';
import { rewardVideoOpen } from '../../actions/rewardVideo';

const NAMESPACE = '[ IronSource ]';
export const RANDOM_END_RESULT_VIDEOS = 1;

class IronSource extends Component {

	componentDidMount(){
		if (this.props.rewardVideo.ironRV !== null) {
			this.props.rewardVideoOpen({name: window.IronRV.EVENTS.OPEN});
			this.props.rewardVideo.ironRV.show();
		}
	}

	componentDidUpdate(prevProps, prevState) {

		//close ironsource modal
		console.log('<IronSource />', this.props.rewardVideo, prevProps);

		//ironsourse modal close
		if (!this.props.rewardVideo.open && prevProps.rewardVideo.open) {

			this.props.handleVideoOverlayClose(this.props.rewardVideo.complete);

			if (!this.props.rewardVideo.complete && this.props.videoAdType!==null) {
				// tracking
				trackingWrapper('event', 'ASgame-skip-ad', {'event_category':'america-says-game'});
			}
		}

		if (this.props.rewardVideo.complete && !prevProps.rewardVideo.complete) {
			this.props.rewardVideo.ironRV.hide();
		}
	}

	render(){
		return <div />;
	}
}

const mapStateToProps = state => ({
  userLoggedIn: state.userLoggedIn,
  user: state.user,
  playCount: state.playCount,
  rewardVideo: state.rewardVideo
});

const mapDispatchToProps = dispatch => ({
  rewardVideoOpen: data => {
    dispatch(rewardVideoOpen(data));
  },
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(IronSource);


// WEBPACK FOOTER //
// ./src/js/components/ads/IronSource.js